import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class AuthService {
  /**
   * Login de usuario
   * @param {string} email
   * @param {string} password
   */
  login(email, password) {
    return axios
      .post(API_URL + '/api/auth/login', {
        email,
        password
      })
      .then(response => {
        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  /**
   * Logout de usuario
   */
  logout() {
    localStorage.removeItem('user');
  }

  /**
   * Obtener usuario actual desde localStorage
   */
  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  /**
   * Verificar si el usuario está autenticado
   */
  isAuthenticated() {
    const user = this.getCurrentUser();
    return user && user.token;
  }
}

export default new AuthService();
